import { Component, Input, OnInit } from '@angular/core';
import { PredefinedAdditionalServiceEnum, AdditionalServiceType, PolicyType, DepositPolicyPaymentTypes, CancelationPolicyChargeTypes, FuelChargingPolicyTypes, ExceededDistancePolicyTypes, AgeRestrictionPolicyTypes, AmountPolicyTypes, AppliedRateTypeID, ExtensionRules, SecurityDepositType, RentalContractTerminationPeriodTypes, AllowedReplacementTypeID, AppliedChargingRate, ModeType, AppliedChargingRateOnExtendedPeriod } from 'src/app/models/enums/BookingEnums';
import { LstPolicyReservationCaseModel } from 'src/app/models/VehicleReservationCaseDetailsModel';
import { IconService } from 'src/app/services/icon.service';
import { faRoad, faBusinessTime, faCalendarAlt, faClipboard, faDollarSign, faListAlt, faMapMarkerAlt, faPlusCircle, faCar, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { faBatteryHalf } from '@fortawesome/free-solid-svg-icons';
import { SearchService } from 'src/app/services/search.service';

@Component({
  selector: 'policies',
  templateUrl: './policies.component.html',
  styleUrls: ['./policies.component.css']
})
export class PoliciesComponent implements OnInit {
  currency:any;
  @Input() lstPolicyReservationCaseModel: LstPolicyReservationCaseModel[];
  faBatteryHalf = faBatteryHalf;
  faMapMarkerAlt = faMapMarkerAlt;
  faPlusCircle = faPlusCircle;
  faTimesCircle = faTimesCircle;
  faDollarSign = faDollarSign;
  faClipboard = faClipboard;
  faCar = faCar;
  faRoad = faRoad;
  faBusinessTime = faBusinessTime;
  faListAlt = faListAlt;
  faCalendarAlt = faCalendarAlt;
  constructor(private iconService:IconService, private matIconRegistry: MatIconRegistry
    , private domSanitizer: DomSanitizer,private currencyService: SearchService) {

      this.currency = currencyService.getCurrency();


    this.matIconRegistry.addSvgIcon(
      "steeringWheel",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.steeringWheel)
    );
    this.matIconRegistry.addSvgIcon(
      "childSeats",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.childSeats)
    );
    this.matIconRegistry.addSvgIcon(
      "GPSNavigation",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.GPSNavigation)
    );
    this.matIconRegistry.addSvgIcon(
      "additionalService",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.additionalService)
    );
   }


  ngOnInit() {


   }
    //#region  Policies Enum

    public get predefinedAdditionalServiceEnum(): typeof PredefinedAdditionalServiceEnum {
      return PredefinedAdditionalServiceEnum;
    }

    public get additionalServiceType(): typeof AdditionalServiceType {
      return AdditionalServiceType;
    }

    public get policyType(): typeof PolicyType {
      return PolicyType;
    }
    public get depositPolicyPaymentTypes(): typeof DepositPolicyPaymentTypes {
      return DepositPolicyPaymentTypes;
    }
    public get appliedChargingRate(): typeof AppliedChargingRate {
      return AppliedChargingRate;
    }
    public get cancelationPolicyChargeTypes(): typeof CancelationPolicyChargeTypes {
      return CancelationPolicyChargeTypes;
    }
    public get allowedReplacementTypeID(): typeof AllowedReplacementTypeID {
      return AllowedReplacementTypeID;
    }
    public get fuelChargingPolicyTypes(): typeof FuelChargingPolicyTypes {
      return FuelChargingPolicyTypes;
    }

    public get rentalContractTerminationPeriodTypes(): typeof RentalContractTerminationPeriodTypes {
      return RentalContractTerminationPeriodTypes;
    }

    public get exceededDistancePolicyTypes(): typeof ExceededDistancePolicyTypes {
      return ExceededDistancePolicyTypes;
    }

    public get extensionRules(): typeof ExtensionRules {
      return ExtensionRules;
    }
    public get appliedChargingRateOnExtendedPeriod(): typeof AppliedChargingRateOnExtendedPeriod {
      return AppliedChargingRateOnExtendedPeriod;
    }
    public get ageRestrictionPolicyTypes(): typeof AgeRestrictionPolicyTypes {
      return AgeRestrictionPolicyTypes;
    }
    public get amountPolicyTypes(): typeof AmountPolicyTypes {
      return AmountPolicyTypes;
    }

    public get appliedRateTypeID(): typeof AppliedRateTypeID {
      return AppliedRateTypeID;
    }

    public get securityDepositType(): typeof SecurityDepositType {
      return SecurityDepositType;
    }
    //#endregion



}
